import { isValid } from 'date-fns';

import { formatInDisplayZone } from '@shared/lib/format-date';

export const parseServiceDate = (value: unknown): Date | null => {
  if (value == null || value === '') {
    return null;
  }

  const date = new Date(value as string | number);
  return isValid(date) ? date : null;
};

export const toSafeIsoString = (value: unknown, fallback: string): string => {
  const date = parseServiceDate(value);
  return date ? date.toISOString() : fallback;
};

export const formatServiceDateTime = (
  value: unknown,
  pattern = 'dd.MM.yyyy, HH:mm:ss',
  fallback = '—',
): string => {
  const date = parseServiceDate(value);
  if (!date) {
    return fallback;
  }

  try {
    return formatInDisplayZone(date, pattern);
  } catch {
    return fallback;
  }
};
